<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'担保服务管理'},{name:'其它担保公司申请列表',goback:true},{name:'担保公司详情'}]" :title="'担保公司详情'"/>
            <!-- 产品详情 -->
            <div class="box detailBas">
                <el-card class="basic box_card" header="" shadow="never">
                  <div class="basisTitle">基础信息：</div>
                 <el-row>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">公司名称：</div>
                          <div class="content">{{companyInfo.companyName}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">公司简介：</div>
                          <div class="content">{{companyInfo.remarks}}</div>
                      </div>
                    </el-col>
                 </el-row>
                 <el-row>
                    <el-col :span="24">
                        <div class="child">
                            <div class="name">LOGO：</div>
                            <div class="content"><img class="logos" :src="companyInfo.frontPath+companyInfo.logoUrl"></div>
                        </div>
                    </el-col>
                 </el-row>
                 <el-row>
                    <el-col :span="8">
                      <div class="childMulti">
                        <div class="name">担保说明：</div>
                        <ul>
                            <li class="content">{{companyInfo.explanation}}</li>
                            <!-- <li class="content">1.本条须知的全部文本，自动换行显示全部文本1.本条须知的全部文本，自动换行显示全部文本1.本条须知的全部文本，自动换行显示全部文本1.本条须知的全部文本，自动换行显示全部文本1.本条须知的全部文本，自动换行显示全部文本</li>
                            <li class="content">2.本条须知的全部文本，自动换行显示全部文本</li>
                            <li class="content">3.本条须知的全部文本，自动换行显示全部文本</li> -->
                        </ul>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="attachment">
                        <div class="name">附件：</div>
                          <ul class="content">
                              <li v-for="(item,i) in companyInfo.fileList" :key="i">
                                  <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                              </li>
                          </ul>
                      </div>
                    </el-col>
                 </el-row>
                </el-card>
                <el-card class="basic box_card mt16" header="" shadow="never">
                  <div class="basisTitle">其它信息：</div>
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">发布账号：</div>
                          <div class="content">{{companyInfo.createUserName}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">发布时间：</div>
                          <div class="content">{{companyInfo.createTime}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">更新账号：</div>
                          <div class="content">{{companyInfo.modifyUserName}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                          <div class="name">更新时间：</div>
                          <div class="content">{{companyInfo.updateTime}}</div>
                      </div>
                    </el-col>
                    <el-col :span="8"></el-col>
                    <el-col :span="8"></el-col>
                  </el-row>
                </el-card>
            </div>
        </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    mixins:[timeMixins],
    components:{
        breadcrumb
    },
    data(){
        return{
            companyInfo:{
                companyName:'',
                classifyValue:'',
                logoUrl:'',
                remarks:'',
                explanation:'',
                fileList:[],
                createUserName:'',
                createTime:'',
                modifyUserName:'',
                updateTime:'',
            },
        }
    },
    created(){
        let id = this.$route.query.id
        this.$axiosz.get('backstage/financial/leasing/details/'+id).then(res=>{
            if(res.code == 200){
                this.companyInfo = res.data
                this.dialogDetail=true;
            }else{
                this.$message({
                    type: 'error',
                    message: res.msg
                });
            }
        })
    },
    methods:{
      //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:calc(100% - 35px);
    .detailBas{
        padding-top: 20px;
        // border-top:1px solid rgba(112, 112, 112, 0.1);
    }
}
.box{
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
    .child{
      margin-top:10px;
    }
}
</style>